module.exports = __webpack_public_path__ + "img/home-icon-ext-white.51180bc0.svg";